module.exports = __webpack_public_path__ + "img/horizontal_1_1_9005.3e95d780.png";